/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class PayrollEmployeeDetailsEditor extends _Ext.GridEditorBase<PayrollEmployeeDetailsRow> {
        protected getColumnsKey() { return "HR.PayrollEmployeeDetails"; }
        protected getLocalTextPrefix() { return PayrollEmployeeDetailsRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
        }
        public getColumns() {

            var columns = super.getColumns();

            //columns.unshift({
            //    field: 'Delete Row',
            //    name: '',
            //    format: ctx => '<a class="inline-action delete-row" title="delete">' +
            //        '<i class="fa fa-trash-o text-red"></i></a>',
            //    width: 24,
            //    minWidth: 24,
            //    maxWidth: 24
            //});

            return columns;
        }


        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var id = this.id(item);
            var target = $(e.target);
            

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {

                        this.view.deleteItem(id);
                        this.view.refresh();
                    });
                }
                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
 
            return buttons;
        }
       
    }
}